<template>
    <div class="content-container">
        <div class="content h-auto">
            <!-- Loading state -->
            <loading-state v-if="loading" fullscreen></loading-state>
            <div class="container" v-if="!loading">
                <!-- Ready to book -->
                <div class="title">
                    <h1>Please enter your code to retrieve your booking</h1>
                </div>
                <div class="card card-body">
                    <pre-booking-completion-form></pre-booking-completion-form>
                </div>
            </div>
        </div>
	</div>
</template>

<script>


    import {mapActions, mapGetters} from "vuex";
    import router from "@/router";

    export default {
        name: 'BookingCompletionLanding',

        mounted() {
            if (router.currentRoute.query['in-store-ref'] && router.currentRoute.query['in-store-ref'].length > 0) {
                this.loading = true;
                this.retrieveBookingByToken(router.currentRoute.query['in-store-ref']).then(() => {
                    router.push({name: 'paymentOptions'});
                }).catch(() => {
                    this.loading = false;
                })
            }
        },

        data() {
            return {
                loading: false,
                bookingToken: "",
                referencePresent: true,
                invalidReferenceError: "",
                invalidReferenceErrorHeader: "",
            }
        },

        computed: {
            ...mapGetters([
                'booking',
                'carrierDetails',
                'devices',
                'parseAddressToString',
                'landingPageLoaded',
                'landingPageLoadSuccess',
                'redirectOnMissingReference',
            ]),
        },

        methods: {
            ...mapActions([
                'retrieveBookingByToken'
            ]),

            getBooking(token) {
                this.loading = true;
                this.retrieveBookingByToken(token).then( () => {
                    this.loading = false;
                    router.push({name: 'checkout'});
                }).catch(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>